export default "__VITE_ASSET__d7a4f2a9__"